import React, { FunctionComponent, memo, useEffect } from 'react';
import { APP_URL, LOGIN_SCREEN_ROUTE } from '../../../config';
import { useOktaAuth } from '@okta/okta-react';
import { AuthError, LoginCallbackErrorProps } from '../types';
import { DependencyContainer } from '../../../DependencyContainer';
import FormattedMessage from '../../../utils/components/FormattedMessage';

const { loginService } = new DependencyContainer();

const LoginCallbackError: FunctionComponent<LoginCallbackErrorProps> = ({
  error,
}) => {
  const { oktaAuth } = useOktaAuth();

  const onError = async () => {
    loginService.setAuthError((error as unknown) as AuthError);
    await oktaAuth.signOut({
      postLogoutRedirectUri: APP_URL + LOGIN_SCREEN_ROUTE,
    });
  };

  useEffect(() => {
    error && onError();
  }, [error]);

  if (loginService.getAuthError()) {
    return null;
  }

  return <FormattedMessage id="loading" />;
};

export default memo(LoginCallbackError);
